// 施工(Construction)の完了状態判定。施工実施ページと施工計画ページの両方から参照する共通概念のため util に置く。
//   draft       = 未完了のまま保存(finished_at が null。旧 is_draft フラグは finished_at の null 判定へ吸収済み)
//   in_progress = 工程実施が無い、または未完了の工程実施が残っている
//   completed   = 全工程実施が完了
type CompletionProcessLike = {
  completed_at: number | null;
  deleted_at: number | null;
};

export type ConstructionCompletionState = "draft" | "in_progress" | "completed";

export function activeProcessExecutions<T extends CompletionProcessLike>(processExecutions: T[]): T[] {
  return processExecutions.filter((p) => p.deleted_at == null);
}

export function constructionCompletionState(args: {
  finished_at: number | null | undefined;
  processExecutions: CompletionProcessLike[];
}): ConstructionCompletionState {
  const activeProcesses = activeProcessExecutions(args.processExecutions);
  if (args.finished_at == null) {
    return "draft";
  }
  if (activeProcesses.length === 0 || activeProcesses.some((p) => p.completed_at == null)) {
    return "in_progress";
  }
  return "completed";
}

// 調合時刻の導出: 施工に紐づく alive な撹拌バッチの撹拌開始時刻(started_at)の最小値。
// 旧 constructions.mixed_at 列は廃止済み(導出できる値をデータ化しない方針)。
type MixedAtStirBatchLike = {
  construction_id: string;
  started_at: number | null;
  deleted_at: number | null;
};

export function deriveMixedAt(constructionId: string, stirBatches: MixedAtStirBatchLike[]): number | null {
  const startTimes: number[] = [];
  for (const stirBatch of stirBatches) {
    if (stirBatch.construction_id === constructionId && stirBatch.deleted_at == null && stirBatch.started_at != null) {
      startTimes.push(stirBatch.started_at);
    }
  }
  if (startTimes.length > 0) {
    return Math.min(...startTimes);
  }
  return null;
}

export function constructionStatusLabel(state: ConstructionCompletionState): string {
  if (state === "completed") {
    return "完了";
  }
  if (state === "in_progress") {
    return "工程未完了";
  }
  return "未完了";
}
